import { Box, Button, Pagination, Paper, Stack } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";

import CourseFilter from "./filter";
import SectionTable from "shared/organisms/tables/table";
import NoDataFound from "shared/molecules/no-data";
import Loader from "pages/build-test/loader";

import { GET_COURSES_LIST } from "utils/graphql/services/global-content-hierarchy/queries";
import { DELETE_COURSE } from "utils/graphql/services/global-content-hierarchy/mutation";

import entitesClient from "utils/graphql/entitiesClient";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { checkFeatureAccess, academicTagsUser } from "utils/role-restriction/helper";
import { table } from "./filter/helper";

const useStyles: any = makeStyles(() => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export default function CoursesPage() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [searchPayload, setSearchPayload] = useState({});
  const [clearValuesTrigger, setClearValuesTrigger] = useState(false);

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const userRoleStr = profileData?.role;
  const userRole = userRoleStr?.split(",");

  const hasModificationAccess = checkFeatureAccess(
    userRole,
    academicTagsUser.ACADEMIC_TAGS_READ_WRITE
  );

  // Queries + Mutations
  const [getCourses, { loading, data }] = useLazyQuery(GET_COURSES_LIST, {
    client: entitesClient,
  });

  // const [deleteCourse] = useMutation(DELETE_COURSE, {
  //   client: entitesClient,
  // });

  const handleChange = (event, value) => {
    setPage(value); // pass new page number to parent
  };

  // Fetch courses whenever search/filter/page changes
  useEffect(() => {
    getCourses({ variables: { filter: { ...searchPayload, limit, page } } });
  }, [searchPayload, limit, page]);

  // Edit handler
  const handleEdit = (id: number,status) => {
    history.push(`/global-content-hierarchy/courses/edit?id=${id}&status=${status}`);
  };

  const handlePreview = (objectId,status) => {
    history.push(`/global-content-hierarchy/courses/edit?id=${objectId}&status=${status}`);
  };

  return (
    <div>
      {/* Create Button */}
      {hasModificationAccess && (
        <ContentRight>
          <Link to="courses/create" className={classes.label}>
            <Button variant="contained">Create Course</Button>
          </Link>
        </ContentRight>
      )}

      {/* Heading */}
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Courses
      </TypographyHeading>

      {/* Filter */}
      <CourseFilter
        onSearch={(values) => setSearchPayload(values)}
        onClear={() => setSearchPayload({})}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />

      {/* Table Section */}
      <Paper elevation={2} sx={{ px: 2, pb: 4, pt: 2, mt: 2 }}>
        {loading && <Loader />}
        {!loading && data?.getCourses?.records?.length > 0 ? (
          <SectionTable
            data={data.getCourses.records}
            table={table}
            id="id"
            name="id"
            // handleDelete={handleDeleteCourse}
            handlePreview={handlePreview}
            rowsPerPageCount={data.getCourses.records.length}
            style="false"
            totalRecords={data.getCourses.meta.total || 0 }
            paginationSegment="false"
            viewSecondaryData="false"
          />
        ) : (
          !loading && <NoDataFound message="No Courses Found" />
        )}

        {/* Pagination */}
          <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getCourses?.meta?.total / limit) || 1}
              page={page}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </div>
  );
}
